<template>
	<div>
		<div   class="sai-item" :style="'background:linear-gradient(226deg, '+colorRow.color+' 0%, '+colorRow.color2+' 100%)'">
			<div class="sai-item-top" >
				<div class="sai-item-type" v-if="row.is_online==1">线上赛事</div>
				<div class="sai-item-type" v-else>线下赛事</div>
				<div class="sai-item-bolid"></div>
				<div class="sa-item-time-range">{{row.saidate_str}}~{{row.saidate_end_str}}</div>
			</div>
			<div class="sai-item-main">
				<div class="sai-item-city" :style="'color:'+colorRow.city">{{row.city}}</div>
				<div class="sai-item-title show-two-row" :style="'color:'+colorRow.title">{{row.name}}</div>
				<div class="sai-item-btn">
					<div class="sai-btn-left" :style="'color:'+colorRow.btn+';border-color:'+colorRow.btn" v-if="row.status!=1" @click="onToWebView()">进入</div>
					<div class="sai-btn-right" :style="'background:'+colorRow.btn"  v-if="row.status<3" @click="onToWebView2()">报名</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		name: "SaiItem",
		components: {},
		props: {
			row: {
				type: Object,
				default: {}
			},
		},

		data: function() {
			return {
				duration: 300,
				colorRow:{},
			};
		},

		mounted() {
			console.log(this.row)
			this.getColor()
		},
		methods: {
			onToWebView() {
				// uni.navigateTo({
				// 	url: '/pages/apps/activity/Activity/Activity?url=https://h5.ccago.cn/cca-h5/dist/activity-activity?' +
				// 		qs.stringify({
				// 			id: this.row.activity_id
				// 		})
				// })

        rbLink({
          name: 'ActivityActivity',
          query: {
            id:this.row.activity_id
          }
        })
			},
			onToWebView2() {
				// uni.navigateTo({
				// 	url: '/pages/apps/isai/SaiApplyFormStep1/SaiApplyFormStep1?url=https://h5.ccago.cn/cca-h5/dist/isai-apply-form-step-1?' +
				// 		qs.stringify({
				// 			saiqu_id: this.row.id
				// 		})
				// })

        rbLink({
          name: 'ISaiApplyFormStep1',
          query: {
            saiqu_id: this.row.id
          }
        })
			},
			onRbLink(item) {
				rbLink({
					name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
					query: item.url.query
				});
			},
			getColor(){
				let colors=[
					{color:'#4BC1FF',color2:'#5599FF',city:'#4FB2FF',title:'#4FB2FF',btn:'#4CBDFF'},
					{color:'#ED34DE',color2:'#B620E0',city:'#D62BDE',title:'#D62BDE',btn:'#E330DE'},
				]

				this.colorRow=colors[parseInt(Math.random()*10)%2]
			},
		},

		filters: {}
	};
</script>

<style scoped>
	.sai-item-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.sai-btn-left {
		width: 1.28rem;
		height: .43rem;
		border-radius: .22rem;
		border: 1px solid #4CBDFF;
		line-height: .43rem;
		text-align: center;
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #51ACFF;
		margin: 0 .1rem;
	}

	.sai-btn-right {
		width: 1.28rem;
		height: .43rem;
		background: #4CBDFF;
		border-radius: .22rem;
		border: 1px solid #fff;
		line-height: .43rem;
		text-align: center;
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		margin: 0 .1rem;
	}

	.sai-item-title {
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #4FB2FF;
		margin-top: .3rem;
		margin-bottom: .35rem;
	}

	.sai-item-city {
		height: .67rem;
		font-size: .48rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #4FB2FF;
		line-height: .67rem;
	}

	.sai-item-main {
		flex: 1;
		background: #fff;
		margin-top: .1rem;
		margin-bottom: .1rem;
		border-radius: .16rem;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: .1rem;
	}

	.sa-item-time-range {
		height: .3rem;
		font-size: .22rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: .3rem;
	}

	.sai-item-bolid {
		width: 1px;
		height: .16rem;
		opacity: 0.8;
		background: #F2F7FF;
		margin-left: .1rem;
		margin-right: .1rem;
	}

	.sai-item-type {
		width: 1.12rem;
		height: .4rem;
		font-size: .28rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: .4rem;
	}

	.sai-item {
		width: 3.25rem;
		height: 3.66rem;
		background: linear-gradient(226deg, #4BC1FF 0%, #5599FF 100%);
		border-radius: .16rem;
		margin-bottom: .2rem;
		padding: .1rem;
		display: flex;
		flex-direction: column;
	}

	.sai-item-top {
		display: flex;
		align-items: center;
	}

	.show-two-row {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
</style>



// WEBPACK FOOTER //
// SaiItem.vue?4a9ef9f2